<template>
	<button type="button" v-on="$listeners">
		<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24">
			<g fill="#4A4A4A" fill-rule="nonzero">
				<path stroke="#FCFCFC" stroke-width=".8" d="M12.943 19.847c-1.5 0-2.945-.28-4.293-.83a.934.934 0 0 0-.716.004l-4.248 1.793 1.431-3.39a.933.933 0 0 0-.162-.984c-1.367-1.535-2.089-3.371-2.089-5.31 0-4.832 4.52-8.764 10.077-8.764S23.02 6.298 23.02 11.13c0 1.146-.281 2.296-.836 3.419a.933.933 0 0 0 1.673.827c.683-1.382 1.03-2.81 1.03-4.246C24.886 5.268 19.528.5 12.942.5 6.358.5 1 5.268 1 11.13c0 2.212.75 4.307 2.176 6.094l-2.103 4.98a.933.933 0 0 0 1.223 1.223l6.015-2.54a13.182 13.182 0 0 0 5.233.813.933.933 0 1 0-.082-1.864 12.04 12.04 0 0 1-.519.01z"/>
				<path d="M12.897 9.924a.933.933 0 1 1 0 1.866.933.933 0 0 1 0-1.866zM16.162 10.857a.933.933 0 1 0 1.866 0 .933.933 0 0 0-1.866 0zM7.765 10.857a.933.933 0 1 0 1.866 0 .933.933 0 0 0-1.866 0z"/>
			</g>
		</svg>
	</button>
</template>
<script>
export default {
	name: 'comments-component',
	inheritAttrs: false,
};
</script>




// WEBPACK FOOTER //
// src/components/shared/icons/comments-component.vue